module.exports = __webpack_public_path__ + "img/pp-44.bd7ee605.jpg";